// extracted by mini-css-extract-plugin
export default {"alphabetCardsActivity":"AlphabetCards_alphabetCardsActivity__nuF4p","cardContainer":"AlphabetCards_cardContainer__IStPS"};